{
  "name": "promote-frontend",
  "version": "2.8.0",
  "description": "Frontend for the Promote App",
  "author": "Retail Commerce Foundation",
  "license": "ISC",
  "repository": {
    "type": "https",
    "url": "https://github.com/nike-retail-commerce-foundation/rcf-promote-frontend"
  },
  "scripts": {
    "start:athlete": "PORT=1234 parcel index.html",
    "start:test": "NODE_ENV=test parcel index.html",
    "start:prod": "NODE_ENV=production parcel index.html",
    "lint": "eslint-output --max-warnings 5 --color .",
    "build": "parcel build --dist-dir dist_p index.html",
    "build:test": "NODE_ENV=test parcel build index.html",
    "jest": "TZ=UTC jest --coverage --passWithNoTests",
    "test": "npm run lint && npm run jest",
    "viewcoverage": "open reports/coverage/index.html",
    "preinstall": "npx npm-force-resolutions"
  },
  "dependencies": {
    "@babel/runtime": "^7.23.2",
    "@emotion/core": "10.0.27",
    "@emotion/styled": "10.0.27",
    "@emotion/styled-base": "10.0.27",
    "@nike/frame-component-library": "^5.4.9",
    "@nike/nike-design-system-components": "^0.11.13",
    "@nike/nike-design-system-icons": "^0.3.21",
    "@nike/rcf-fp": "^0.5.0",
    "@reduxjs/toolkit": "^1.9.7",
    "@zxing/library": "^0.21.1",
    "clsx": "^1.2.1",
    "emotion-theming": "10.0.27",
    "i18n-iso-countries": "^6.8.0",
    "intersection-observer": "^0.10.0",
    "locale-code": "^2.0.2",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.45",
    "numeral": "^2.0.6",
    "papaparse": "^5.4.1",
    "parcel": "^2.10.0",
    "prop-types": "^15.8.1",
    "rcffus-sps-translations": "^1.10.0",
    "react": "^17.0.1",
    "react-csv-downloader": "^3.1.0",
    "react-dom": "^17.0.1",
    "react-intersection-observer": "^8.34.0",
    "react-redux": "^7.2.9",
    "react-router-dom": "^5.3.4",
    "react-select": "^3.2.0",
    "webrtc-adapter": "^7.7.1"
  },
  "devDependencies": {
    "@babel/cli": "^7.23.0",
    "@babel/core": "^7.24.9",
    "@babel/plugin-proposal-nullish-coalescing-operator": "^7.18.6",
    "@babel/plugin-proposal-optional-chaining": "^7.21.0",
    "@babel/plugin-proposal-private-methods": "^7.18.6",
    "@babel/plugin-syntax-bigint": "^7.8.3",
    "@babel/plugin-syntax-typescript": "^7.24.7",
    "@babel/preset-env": "^7.23.2",
    "@babel/preset-react": "^7.22.15",
    "@nike/eslint-config-rcf": "^0.6.0",
    "@testing-library/jest-dom": "^5.17.0",
    "@testing-library/react": "^12.1.5",
    "babel-preset-nano-react-app": "^0.1.0",
    "buffer": "^6.0.3",
    "eslint": "^7.32.0",
    "eslint-output": "^2.0.4",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-junit": "^13.2.0",
    "jest-stare": "^2.5.1",
    "process": "^0.11.10"
  },
  "resolutions": {
    "node-forge": "0.10.0"
  }
}
